import { Button } from "@reliance/design-system";
import React from "react";
import Pill from "../img/Pill.svg";
import { Heading } from "@reliance/design-system";
import { logAnalyticsEvent } from "../firebaseInit";
import { eventName } from "../services/constants";
import { useTranslation } from "react-i18next";

const FulfilmentConfirmation = ({
  handleBackToConsultation,
  DELIVERYTYPE,
  deliveryType,
  contactDetails,
  pickupType,
  ...props
}) => {
  const { t } = useTranslation(["consultations"]);
  const { prescriptionId } = props;

  if (deliveryType === DELIVERYTYPE.delivery) {
    logAnalyticsEvent(eventName.VIEW_PRESCRIPTION_DELIVERY_SUCCESS, {
      states: contactDetails?.state,
      item_name: prescriptionId,
      type: "delivery",
    });
  } else if (deliveryType === DELIVERYTYPE.pickup) {
    logAnalyticsEvent(eventName.VIEW_PRESCRIPTION_PICKUP_SUCCESS, {
      states: contactDetails?.state,
      item_name: prescriptionId,
      type: pickupType,
    });
  }
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 15,
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px 0px 20px 0px",
      }}
    >
      <img src={Pill} alt="" width={50} />
      {deliveryType === DELIVERYTYPE.pickup && (
        <>
          <Heading
            level={"h4"}
            style={{ textAlign: "center", marginBottom: 10 }}
          >
            {t("prescriptionPickupRequestSubmissionHeading")}
          </Heading>
          <p style={{ fontSize: 13 }}>
            {t("prescriptionPickupRequestSubmissionCodeWaitTime")}
          </p>
          <Heading level={"h1"} style={{ fontSize: 16 }}>
            {t("prescriptionPickupRequestWaitForCode")}
          </Heading>
          <p style={{ fontSize: 13 }}>
            {t("prescriptionPickupRequestShowCode")}
          </p>
        </>
      )}

      {deliveryType === DELIVERYTYPE.delivery && (
        <>
          <Heading
            level={"h4"}
            style={{ textAlign: "center", marginBottom: 10 }}
          >
            {t("prescriptionDeliverypRequestSubmissionHeading")}
          </Heading>
          <p style={{ fontSize: 13 }}>
            {t("prescriptionDeliveryRequestSubmissionCodeWaitTime")}
          </p>

          <p style={{ fontSize: 13 }}>
            {t("prescriptionDeliveryRequestShowCode")}
          </p>
        </>
      )}

      <Button
        onClick={handleBackToConsultation}
        style={{
          fontSize: 14,
          height: 50,
          width: "80%",
          marginTop: 10,
        }}
      >
        {t("backToConsultationButtonText")}
      </Button>
    </div>
  );
};

export default FulfilmentConfirmation;
